module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "notification",
    staticClass: "tw-flex tw-rounded tw-border tw-max-w-full tw-overflow-hidden",
    class: {
      'tw-border-red-400 tw-bg-red-50': _vm.ifTypeIsFailed(),
        'tw-border-green-400 tw-bg-green-50': _vm.ifTypeIsSuccess(),
        'tw-border-orange-400 tw-bg-orange-50': _vm.ifTypeIsWarning(),
        'tw-border-blue-400 tw-bg-blue-50': _vm.ifTypeIsInformation()
    },
    attrs: {
      "data-testid": "toaster"
    }
  }, [_c('div', {
    staticClass: "tw-px-3 tw-flex tw-items-center",
    class: {
      'tw-bg-red-400': _vm.ifTypeIsFailed(),
        'tw-bg-green-400': _vm.ifTypeIsSuccess(),
        'tw-bg-orange-400': _vm.ifTypeIsWarning(),
        'tw-bg-blue-400': _vm.ifTypeIsInformation()
    }
  }, [_c('span', {
    staticClass: "fa-solid tw-text-xl tw-text-white",
    class: _vm.getTypeIcon()
  })]), _vm._v(" "), _c('div', {
    staticClass: "tw-grow tw-py-2 tw-px-3 tw-relative"
  }, [_c('div', {
    ref: "bgTime",
    staticClass: "tw-z-0 tw-absolute tw-inset-y-0 tw-left-0 tw-transition-all tw-duration-75",
    class: {
      'tw-bg-red-100/75': _vm.ifTypeIsFailed(),
        'tw-bg-green-100/75': _vm.ifTypeIsSuccess(),
        'tw-bg-orange-100/75': _vm.ifTypeIsWarning(),
        'tw-bg-blue-100/75': _vm.ifTypeIsInformation()
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tw-flex tw-items-center tw-relative tw-z-10"
  }, [_c('div', {
    staticClass: "tw-font-bold",
    class: {
      'tw-text-red-400': _vm.ifTypeIsFailed(),
        'tw-text-green-400': _vm.ifTypeIsSuccess(),
        'tw-text-orange-400': _vm.ifTypeIsWarning(),
        'tw-text-blue-400': _vm.ifTypeIsInformation()
    },
    attrs: {
      "data-testid": "toaster-title"
    }
  }, [_vm._v(_vm._s(_vm.getTypeTitle()))]), _vm._v(" "), _c('div', {
    staticClass: "tw-text-gray-500 tw-text-sm tw-font-light tw-ml-2"
  }, [_vm._v("\n                    (" + _vm._s(_vm.notification.time) + ")\n                ")]), _vm._v(" "), (_vm.canClose) ? _c('span', {
    staticClass: "tw-bg-white tw-cursor-pointer hover:tw-text-white tw-duration-200 tw-absolute tw--top-[8px] tw--right-[12px] tw-w-7 tw-h-7 tw-flex tw-items-center tw-justify-center tw-border-b tw-border-l tw-rounded-bl",
    class: {
      'tw-text-red-400 hover:tw-bg-red-400 tw-border-red-400': _vm.ifTypeIsFailed(),
        'tw-text-green-400 hover:tw-bg-green-400 tw-border-green-400': _vm.ifTypeIsSuccess(),
        'tw-text-orange-400 hover:tw-bg-orange-400 tw-border-orange-400': _vm.ifTypeIsWarning(),
        'tw-text-blue-400 hover:tw-bg-blue-400 tw-border-blue-400': _vm.ifTypeIsInformation()
    },
    attrs: {
      "data-testid": "toaster-close-button",
      "title": "Supprimer la notification"
    },
    on: {
      "click": function($event) {
        _vm.close()
      }
    }
  }, [_c('span', {
    staticClass: "fa-solid fa-xmark"
  })]) : _vm._e()]), _vm._v(" "), (_vm.notification.message !== '') ? _c('div', {
    staticClass: "tw-break-anywhere tw-z-10 tw-relative",
    attrs: {
      "data-testid": "toaster-message"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.notification.message)
    }
  }) : _c('div', [_vm._v("Message manquant..")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-222f0ab0"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shared/components/notification/notification-item/notification-item.vue.html
// module id = uspy
// module chunks = 2